import React, { Component, useReducer } from 'react';
import {Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, Form, FormGroup, InputGroupAddon, Container, Label, InputGroup} from "reactstrap";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import axios from 'axios';
import Background from '../images/image_3.jpg'
import { FaKey } from 'react-icons/fa'
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import {Triangle} from 'react-loader-spinner'

  class ResetPassword extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        show_network_error: false,
        button_disabled: false,
        password: '',
        password_confirmation: '',
        status: ''
    };
    this.ShowNetworkErrorMessage = () => {
        var show = this.state.show_network_error
        if(show==true){
            return<h6 style={{color: 'red', marginTop: '-50px'}}>
                There seems to be a problem connecting to our servers. Please check your network connection and try again.
                <br/><br/>
            </h6>
        }else{
            return<div></div>
        }
    }
    
    this.PasswordConfirmation = () => {
      var password = this.state.password
      var password_confirmation = this.state.password_confirmation
      if((password!='') && (password_confirmation!='')){
          if(password!=password_confirmation){
              return<div style={{color: 'red'}}>
                  <br/>
                  Your passwords do not match
              </div>
          }else{
              return<div style={{color: 'green'}}>
                  <br/>
                  Passwords match
              </div>
          }
      }else{
          return<div>
              <br/>
          </div>
      }
    }
    this.SelectRender = () => {
      var status = this.state.status
      if(status=='Password verification token has been used already'){
        return<div>
          <br/>
          <h5>
              This password verification token has already been used
          </h5>
        </div>
      }else if(status=='Loading'){
        return<div>
            <br/>
            <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
            ONFIT
            </h1>
            <br/><br/>
            <Triangle
                color="#1FACED"
                height={130}
                width={130}
            />
            <h3 style={{marginTop: '50px'}}>
            Loading...
            </h3>
            <h6 style={{marginTop: '50px'}}>
                Taking too long to load? Check your internet connection and reload the page.
            </h6>
            <br/><br/>
        </div>
      }else if(status=='Password verification token valid'){
        return<Container>
          <this.ShowNetworkErrorMessage/>
          <Row>
            <Col>
                <InputGroup>
                    <InputGroupAddon addonType="prepend"><FaKey style={{margin:'10px'}}/></InputGroupAddon>
                        <Input style={{border: 'none', borderBottom: '1px solid #828884', backgroundColor: 'inherit'}} placeholder="Password" type="password" name="password" id="password" 
                        value={this.state.password} onChange={this.HandleChange} />
                </InputGroup>
            </Col>
            <Col>
                <InputGroup>
                    <InputGroupAddon addonType="prepend"><FaKey style={{margin:'10px'}}/></InputGroupAddon>
                        <Input style={{border: 'none', borderBottom: '1px solid #828884', backgroundColor: 'inherit'}} placeholder="Repeat your password" type="password" name="password_confirmation" id="password_confirmation" 
                        value={this.state.password_confirmation} onChange={this.HandleChange} />
                </InputGroup>
            </Col>
          </Row>
          <this.PasswordConfirmation/>
          <br/><br/>
          <Button disabled={this.state.button_disabled} onClick={this.ResetPassword} style={{backgroundColor: '#1faced', border: 'none'}}>
              Save New Password
          </Button>
        </Container>
      }else if(status=='Invalid password verification token'){
        return<div>
          <br/>
          <h5>
              This password verification token is invalid, please make sure you clicked on the link that we sent to your email address 
              when you requested a password reset
          </h5>
        </div>
      }else{
        return<div>
            <br/>
            <h1 style={{fontWeight: 'bold'}}>
              Onfit
            </h1>
            <h3 style={{marginTop: '80px'}}>
              Loading...
            </h3>
            <h6 style={{marginTop: '50px'}}>
                Taking too long to load? Check your internet connection and reload the page.
            </h6>
        </div>
      }
    }
    this.ResetPassword = (e) =>{
      this.setState({status: 'Loading', button_disabled: true})
        e.preventDefault();
        const { cookies } = this.props;
        var token = this.props.match.params.token
        var password = this.state.password
        var password_confirmation = this.state.password_confirmation

        if((password=='')||(password_confirmation=='')){
          alert('Password fields cannot be empty.')
        }else{
          if(password!=password_confirmation){
            alert('Your password and its confirmation do not match.')
          }else{
            var data = new FormData()
            data.append('token', token)
            data.append('password', password)

            axios.post(Backend_Url + 'resetPassword', data)
            .then((res) => {
              let result = res.data
              if(result=='Invalid password verification token'){
                alert('Invalid password reset token used')
              }else if(result=='Password verification token has been used already'){
                alert('Password reset token has been used already')
              }else if(result=='Password has been reset successfully'){
                alert("Your password has been reset successfully, you'll now be redirected to the Signin page.")
                let port = (window.location.port ? ':' + window.location.port : '');
                window.location.href = '//' + window.location.hostname + port + '/signin';
              }else{
                alert('Unknown result, please try again')
              }
              this.setState({button_disabled: false})
            }).catch((error) => {
              this.setState({button_disabled: false, show_network_error: true, status: 'Password verification token valid'})
            })
          }
        }

    };
    this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
    };
    }

    componentDidMount() {
      const { cookies } = this.props;
      if(cookies.get('token')!=null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/user-home';
      }else{
        const token = this.props.match.params.token
        axios.get(Backend_Url + 'checkPasswordResetToken/' + token)
        .then((res) => {
          let result = res.data
          if(result=='Password verification token has been used already'){
              this.setState({status: 'Password verification token has been used already'})
          }
          if(result=='Password verification token valid'){
              this.setState({status: 'Password verification token valid'})
          }
          if(result=='Invalid password verification token'){
              this.setState({status: 'Invalid password verification token'})
          }
        }).catch((error) => {
              console.log(error)
        })
      }
  }

    render() {
      return (
        <div style={{backgroundImage: "url(" + Background + ")"}}>
          <div style={{backgroundColor: '#FFFFFF', opacity: 0.85, minHeight: '550px'}}>
            <Helmet>
            <title>Reset password - Onfit</title>
            </Helmet>
            <Container>
                <br/><br/>
                <h4 style={{color: '#1faced'}}>
                    Reset Password
                </h4>
                <br/><br/><br/>
                <this.SelectRender/>
            </Container>
          </div>
        </div>
      );
    }

  };
  
  export default withCookies(ResetPassword);